import { Button, Grid, makeStyles, Paper, TextField } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from '../../../hooks/useForm';
import { cleanComprobantesMesaEntrada, getBuscadorMesaEntradas } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { autoFill } from '../../../helpers/autoFill';
import { AutoCompleteEfectorFacturacion } from '../../liquidaciones/UI/AutoCompleteEfectorFacturacion';
import { useDispatch, useSelector } from 'react-redux';
import { BUSCADOR_MESA_ENTRADAS, TIPO_COMPROBANTE_DOCUMENTO } from '../../../utils/constants';
import moment from 'moment';
import IconEstado from '../../autorizaciones/UI/IconEstado';
import { GenericCheckboxTable } from '../../atomic/organisms/GenericTable';
import { ModalHistorialExpedientes } from '../UI/ModalHistorialExpedientes';
import { ModalInformacionExpediente } from '../UI/ModalInformacionExpediente';
import { Info } from '@material-ui/icons';
import { ImpresionComprobante } from '../UI/ImpresionComprobante';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: theme.spacing(1)
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
}));

export const BuscadorExpedientes = () => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const componentRef = useRef();

    const [selected, setSelected] = useState([]);
    const [openModalInformacion, setOpenModalInformacion] = useState({
        open: false,
        value: null
    });
    const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState({
        open: false,
        value: null
    });


    const {
        efectorSeleccionado,
    } = useSelector((state) => state.liquidaciones);
    const { comprobantes } = useSelector(state => state.mesaEntrada);

    const stateInitial = {
        idExpediente: '',
        idExpedienteSV: '',
        nroFactura: '',
        nroSucursal: '',
        idEfectorFacturacion: ''
    };

    const [
        formValues,
        handleInputChange, ,
        setearValor
    ] = useForm(stateInitial);

    const { idExpediente, idExpedienteSV, nroSucursal, nroFactura, idEfectorFacturacion } = formValues;

    useEffect(() => {
        setearValor("idEfectorFacturacion", efectorSeleccionado?.idEfectorFacturacion ? efectorSeleccionado?.idEfectorFacturacion : null);
        if (efectorSeleccionado) {
            const parametros = {
                tipoConsulta: BUSCADOR_MESA_ENTRADAS.POR_ID_EFECTOR,
                idEfectorFacturacion: idEfectorFacturacion,
                idExpediente: idExpediente,
                idExpedienteSV: idExpedienteSV,
                nroSucursal: nroSucursal,
                nroFactura: nroFactura,
            }
            buscar(parametros);
        }

        if (efectorSeleccionado === null) {
            dispatch(cleanComprobantesMesaEntrada());
        }
    }, [efectorSeleccionado, formValues?.idEfectorFacturacion])


    const buscar = (params) => {
        dispatch(getBuscadorMesaEntradas(params));
    }


    console.log(efectorSeleccionado)
    console.log(formValues)
    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12}>
                    <Grid container component={Paper} alignItems="center" style={{ padding: "0.25rem" }}>
                        <Grid item xs={2} style={{ padding: "0.25rem" }}>
                            <TextField
                                variant="outlined"
                                margin='normal'
                                fullWidth
                                label="Id Expediente"
                                onChange={(e) => {
                                    handleInputChange(e);
                                }}
                                autoComplete="off"
                                type="number"
                                value={idExpediente}
                                name="idExpediente"
                                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                            />
                        </Grid>
                        <Grid item xs={1} style={{ padding: "0.25rem" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size='small'
                                disabled={idExpediente.length < 5}
                                type='button'
                                onClick={() => {
                                    const parametros = {
                                        tipoConsulta: BUSCADOR_MESA_ENTRADAS.POR_ID_EXPEDIENTE,
                                        idEfectorFacturacion: idEfectorFacturacion,
                                        idExpediente: idExpediente,
                                        idExpedienteSV: idExpedienteSV,
                                        nroSucursal: nroSucursal,
                                        nroFactura: nroFactura,
                                    }
                                    buscar(parametros);
                                }}
                                style={{
                                    marginTop: '1px',
                                }}
                            >
                                Buscar
                            </Button>
                        </Grid>
                        <Grid item xs={2} style={{ padding: "0.25rem" }}>
                            <TextField
                                variant="outlined"
                                margin='normal'
                                fullWidth
                                label="Id Expediente SV"
                                onChange={(e) => {
                                    handleInputChange(e);
                                }}
                                autoComplete="off"
                                type="number"
                                value={idExpedienteSV}
                                name="idExpedienteSV"
                                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                            />
                        </Grid>
                        <Grid item xs={1} style={{ padding: "0.25rem" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size='small'
                                disabled={idExpedienteSV.length < 5}
                                onClick={() => {
                                    const parametros = {
                                        tipoConsulta: BUSCADOR_MESA_ENTRADAS.POR_ID_EXPEDIENTE_SV,
                                        idEfectorFacturacion: idEfectorFacturacion,
                                        idExpediente: idExpediente,
                                        idExpedienteSV: idExpedienteSV,
                                        nroSucursal: nroSucursal,
                                        nroFactura: nroFactura,
                                    }
                                    buscar(parametros);
                                }}
                                style={{
                                    marginTop: '1px',
                                }}
                            >
                                Buscar
                            </Button>
                        </Grid>
                        {/* </Grid>
                    <Grid container component={Paper} alignItems="center" > */}
                        <Grid item xs={1} style={{ padding: "0.25rem" }}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Número Sucursal"
                                autoComplete="off"
                                name="nroSucursal"
                                type="number"
                                value={nroSucursal}
                                inputMode="numeric"
                                onChange={e => {
                                    autoFill({
                                        setearValor,
                                        value: e.target.value,
                                        num: 5,
                                        name: "nroSucursal"
                                    })
                                }}
                                // error={nroSucursal}
                                // helperText={formErrors.nroSucursal || "Ingrese 5 dígitos."}
                                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                            />
                        </Grid>
                        <Grid item xs={1} style={{ padding: "0.25rem" }}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Número Factura"
                                autoComplete="off"
                                name="nroFactura"
                                type="number"
                                value={nroFactura}
                                inputMode="numeric"
                                onChange={e => {
                                    autoFill({
                                        setearValor,
                                        value: e.target.value,
                                        num: 8,
                                        name: "nroFactura"
                                    })
                                }}
                                // error={!!formErrors.nroFactura}
                                // helperText={formErrors.nroFactura || "Ingrese 8 dígitos."}
                                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                            />
                        </Grid>
                        <Grid item xs={1} style={{ padding: "0.25rem" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size='small'
                                disabled={nroSucursal.length < 5 && nroFactura.length < 8}
                                onClick={() => {
                                    const parametros = {
                                        tipoConsulta: BUSCADOR_MESA_ENTRADAS.POR_NRO_FACTURA,
                                        idEfectorFacturacion: idEfectorFacturacion,
                                        idExpediente: idExpediente,
                                        idExpedienteSV: idExpedienteSV,
                                        nroSucursal: nroSucursal,
                                        nroFactura: nroFactura,
                                    }
                                    buscar(parametros);
                                }}
                                style={{
                                    marginTop: '1px',
                                }}
                            >
                                Buscar
                            </Button>
                        </Grid>
                        <Grid item xs={3} style={{ padding: "0.25rem" }}>
                            <AutoCompleteEfectorFacturacion todos dontExecuteFetch />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ padding: "0.25rem", textAlign: "left" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size='small'
                        type='button'
                        onClick={() => {
                            dispatch(cleanComprobantesMesaEntrada());
                        }}
                        style={{
                            marginTop: '1px',
                        }}
                    >
                        REINICIAR BUSCADOR
                    </Button>
                </Grid>
                <Grid item xs={12} component={Paper} style={{ marginTop: "0.5em" }}>
                    <GenericCheckboxTable
                        ref={componentRef}
                        align="center"
                        selected={selected}
                        setSelected={setSelected}
                        data={comprobantes.map(item => ({ ...item, id: item.idExpediente }))}
                        //disabledCheck={disabledCheck}
                        withoutPagination={comprobantes.length === 0}
                        // withDeleteButton={{
                        //     condition: (item) => (
                        //         item.idEstado === ESTADOS_COMRPOBANTES.PENDIENTE_ENVIO ||
                        //         item.idEstado === ESTADOS_COMRPOBANTES.RETORNADA ||
                        //         item.idEstado === ESTADOS_COMRPOBANTES.PROFORMA_ENVIADA
                        //     ),
                        //     deleteProps: {
                        //         handleDelete: (item) => handleDelete(item.idExpediente),
                        //         mensajeEliminacion: "¿Desea anular este comprobante?",
                        //         permiso: MESA_ENTRADA_PERMISOS.BAJA,
                        //         motivoBaja, setMotivoBaja, validators, errorMessages
                        //     }
                        // }}
                        columns={[
                            {
                                label: "Historial",
                                customBody: (item) => (
                                    <Info onClick={() => setOpenModalHistorialCambios({ open: true, value: item })} />
                                )
                            },
                            {
                                label: "Estado",
                                customBody: (item) => (
                                    <IconEstado
                                        useColorTable={true}
                                        texto={item?.letra}
                                        backgroundColor={item?.color}
                                        descripcion={item?.descripcionEstado}
                                    />
                                )
                            },
                            {
                                label: "Id Comprobante",
                                id: "idExpediente",
                                sort: true
                            },
                            {
                                label: "Id Comprobante SV",
                                id: "idExpedientes",
                                sort: true
                            },
                            {
                                label: "Fecha Recepción",
                                customBody: (item) => moment(item?.fechaRecepcion).format("DD/MM/YYYY")
                            },
                            {
                                label: "Prestadores",
                                customBody: (item) => item?.razonSocial || item?.nombreFantasia
                            }
                            ,
                            {
                                label: "Tipo Comprobante",
                                id: "descripcionTipoComprobante"
                            },
                            {
                                label: "N° Comprobante",
                                customBody: (item) => item.nroFactura ?
                                    item?.descripcionTipoFactura
                                        ? `${item.descripcionTipoFactura} / ${item?.nroSucursal.toString().padStart((5), '0') || "00000"}-${item?.nroFactura.toString().padStart((8), '0')}`
                                        : `${item?.nroSucursal.toString().padStart((5), '0')}-${item?.nroFactura.toString().padStart((8), '0')}`
                                    : "No posee N° Comprobante"
                            },
                            {
                                label: "Total Comprobante",
                                customBody: (item) => `$ ${parseFloat(item?.totalComprobante).toFixed(2)}`
                            },
                            {
                                label: "Fecha Comprobante",
                                customBody: (item) => moment(item?.fechaInicioVigencia).format("DD/MM/YYYY")
                            },
                            {
                                label: "Fecha Vencimiento",
                                customBody: (item) => moment(item?.fechaFinVigencia).format("DD/MM/YYYY")
                            }
                            ,
                            // {
                            //     sort: true,
                            //     label: "Destino",
                            //     id: "idDestino",
                            //     customBody: (item) => (
                            //         <Button
                            //             variant={estadoComprobante !== '1' ? "contained" : "outlined"}
                            //             color="secondary"
                            //             disabled={estadoComprobante !== '1'}
                            //             onClick={e => handleOpenModal(e, {
                            //                 item,
                            //                 action: MESA_ENTRADA_GESTION_BUTTONS.MODIFICAR_DESTINO,
                            //                 single: true
                            //             })}
                            //         >
                            //             {destinos.find(destino => destino?.id === item.idDestino)?.descripcion}
                            //         </Button>
                            //     )
                            // },
                            {
                                label: "Información",
                                customBody: (item) => (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={() => setOpenModalInformacion({ open: true, value: item })}
                                        type='submit'
                                    >
                                        VER
                                    </Button>
                                )
                            },
                            {
                                label: "Impresion",
                                customBody: (item) => (
                                    <ImpresionComprobante comprobante={item} documento={false} />
                                )
                            },

                        ]}
                    />
                </Grid>
                {openModalHistorialCambios.open && (
                    <ModalHistorialExpedientes
                        open={openModalHistorialCambios}
                        closeModalHandler={() => {
                            setOpenModalHistorialCambios({ open: false, value: null });
                        }}
                        expediente={openModalHistorialCambios.value}
                    />
                )}
                {openModalInformacion.open && (
                    <ModalInformacionExpediente
                        open={openModalInformacion}
                        tipoComprobanteDocumento={TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION}
                        closeModalHandler={() => {
                            setOpenModalInformacion({ open: false, value: null });
                        }}
                        expediente={openModalInformacion.value}
                    />
                )}
            </Grid>
        </div>
    )
}
